import React from 'react';

import { Attachment } from 'Shared/types/Attachment.type';

import WpModal from 'Wpds/components/modal/WpModal';
import AttachmentViewer from './AttachmentViewer';

type Props = {
  isOpen: boolean;
  attachment: Attachment;
  toggleModal?: Function;
  handleDownload?: Function;
};

const AttachmentViewerModal = ({ isOpen, toggleModal, attachment, handleDownload }: Props) => {
  return (
    <WpModal isOpen={isOpen} size="full" hideBackdrop zIndex={1051}>
      <AttachmentViewer attachment={attachment} toggleModal={toggleModal} handleDownload={handleDownload} />
    </WpModal>
  );
};

export default AttachmentViewerModal;
